import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Products from "./components/Products";
import WhyUs from "./components/WhyUs";
import Story from "./components/Story";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import Gallery from "./components/Gallery";
import Preloader from "./components/Preloader";
import ScrollToTop from "./components/ScrollToTop";


export default function App() {
  return (
    <>
      <Preloader />
      <Navbar />
      <Hero />
      <TrustBar />
      <Products />
      <Gallery />
      <WhyUs />
      <Story />
      <CTA />
      <Footer />
      <MobileCTA />
      <ScrollToTop />
    </>
  );
}
